import { OrganizationPlanData } from '@/features/subscriptions/types/subscription-types';

export const organizationPlans: OrganizationPlanData[] = [
  {
    id: 'essential',
    planType: 'essential',
    type: 'organization',
    hasTrial: true,
    features: [
      {
        textKey: 'dashboard_insights',
        included: true,
      },
      {
        textKey: 'storage_1gb',
        included: true,
      },
      {
        textKey: 'unlimited_notifications',
        included: true,
      },
      {
        textKey: 'unlimited_members',
        included: true,
      },
      {
        textKey: 'partner_hub',
        included: true,
      },
      {
        textKey: 'support_24_7',
        included: true,
      },
    ],
    includedProject: {
      seats: 1,
      subprojects: 1,
      standardKpis: 3,
      derivativeKpis: 1,
    },
  },
  {
    id: 'pro',
    planType: 'pro',
    type: 'organization',
    hasTrial: true,
    features: [
      {
        textKey: 'all_essential',
        included: true,
      },
      {
        textKey: 'ai_insights_forecasts',
        included: true,
      },
      {
        textKey: 'anomaly_detection',
        included: true,
      },
      {
        textKey: 'intelligent_dashboards',
        included: true,
      },
      {
        textKey: 'storage_5gb',
        included: true,
      },
      {
        textKey: 'support_24_7',
        included: true,
      },
    ],
    includedProject: {
      seats: 1,
      subprojects: 1,
      standardKpis: 3,
      derivativeKpis: 1,
    },
  },
  {
    id: 'enterprise',
    planType: 'enterprise',
    type: 'organization',
    hasTrial: false,
    features: [
      {
        textKey: 'all_pro',
        included: true,
      },
      {
        textKey: 'unlimited_zapier',
        included: true,
      },
      {
        textKey: 'unlimited_storage',
        included: true,
      },
      {
        textKey: 'support_24_7',
        included: true,
      },
    ],
    includedProject: {
      seats: 1,
      subprojects: 1,
      standardKpis: 3,
      derivativeKpis: 1,
    },
  },
];
